































import IconBase from "@/common/components/atoms/IconBase.vue";

import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Prop, Vue, Component, PropSync, Emit } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class CategoryNaviItemLink extends Vue {
  @Prop({ type: String, default: "button" }) tag!: string;
  @Prop({ type: Object, required: true }) paramsObject!: Record<string, any>;
  @Prop({ type: Boolean, default: true }) isChildItem!: boolean;

  get childClassName() {
    const isChildItem = this.isChildItem;
    return isChildItem ? "p-the-header-navi-on-general__link__text--child" : "";
  }

  emitChildItemObject(emitValue: any) {
    this.$emit("emit-child-item-object", emitValue);
  }
}
